const mentors = [
  {
    name: "Dr. Ritu Jain G",
    specialization: "Artificial Intelligence & Machine Learning Mentor",
    Information: "Guides students in building intelligent systems using AI, Machine Learning, and Generative AI technologies. Helps develop practical projects involving data analysis, automation, and predictive modeling."
  },
  {
    name: "Dr. Piyush Gupta",
    specialization: "Data Science",
    Information: "Supports learners in extracting insights from data using statistical analysis, visualization, and machine learning techniques. Guides real-world projects involving business intelligence and data-driven decision-making."
  },
  {
    name: "Dr. Archana Mittal",
    specialization: "Social Develpment & Sustainability",
    Information: "Supports students in developing intelligent Society Development & Sustainability solutions. Combines programming, electronics, and AI concepts to solve real-world engineering challenges"
  },
  {
    name: "Suraksha Vidhyarthi",
    specialization: "AI & Cloud Computing",
    Information: "Mentors students on cloud platforms, virtualization, containerization, and scalable application deployment. Helps build industry-ready skills in cloud architecture and DevOps practices."
  },
  {
    name: "Priyanka Shah",
    specialization: "AI & Forward Deployment Engineering",
    Information: "Mentors students on Platform Deployment, virtualization, containerization, and scalable application deployment. Helps build industry-ready skills in cloud architecture and DevOps practices."
  },
  {
    name: "Sumant Khapre",
    specialization: "Full Stack Development",
    Information: "Guides learners in designing and developing modern web applications using frontend and backend technologies. Emphasizes best practices in coding, databases, APIs, and software engineering."
  },
  {
    name: "Aishwarya Patil",
    specialization: "Artificial Intelligence",
    Information: "Guides students in building intelligent systems using AI, Machine Learning, and Generative AI technologies. Helps develop practical projects involving data analysis, automation, and predictive modeling."
  },
  {
    name: "Baranika S",
    specialization: "Cybersecurity",
    Information: "Provides expertise in network security, ethical hacking, digital forensics, and cyber defense strategies. Assists students in identifying vulnerabilities and implementing secure technology solutions."
  },
  {
    name: "Vivek Khandelval",
    specialization: "Blockchain Technology",
    Information: "Helps students understand decentralized systems, smart contracts, and blockchain application development. Provides hands-on guidance for building secure and transparent digital solutions."
  },
  {
    name: "C.K Vishvakarma",
    specialization: "Internet of Things (IoT)",
    Information: "Supports the development of connected devices, sensor networks, and smart automation systems. Guides students in integrating hardware, software, and cloud technologies for real-world applications."
  },
  {
    name: "Robin Vergese",
    specialization: "DevOps & Automation",
    Information: "Teaches modern software delivery practices including CI/CD, infrastructure automation, and container orchestration. Helps students improve software reliability, scalability, and deployment efficiency."
  },
  {
    name: "Sumant Khapre",
    specialization: "Mobile Application Development",
    Information: "Guides students in creating Android, iOS, and cross-platform mobile applications. Focuses on user experience, performance optimization, and real-world app deployment."
  },
  {
    name: "Vidhya S",
    specialization: "Software Engineering",
    Information: "Provides mentorship in software design, architecture, testing, and project management methodologies. Helps students develop industry-standard applications while following best engineering practices."
  },
  {
    name: "Akanksha Mittal",
    specialization: "UI/UX Design",
    Information: "Assists learners in creating intuitive, user-centered digital experiences through effective design principles. Guides prototyping, usability testing, and modern interface development."
  },
   {
    name: "Dr. Sri Kalavani",
    specialization: "Robotics & Automation",
    Information: "Supports students in developing intelligent robotic systems and automation solutions. Combines programming, electronics, and AI concepts to solve real-world engineering challenges"
  },
  {
    name: "Dr. Shashi Khad",
    specialization: "Sustainability & AI",
    Information: "Supports students in developing intelligent Sustainability solutions. Combines programming, electronics, and AI concepts to solve real-world engineering challenges"
  }
];

export default mentors;